module.exports = __webpack_public_path__ + "static/media/donoghue.80a6a13c.jpg";